
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRendezvousById, selectCurrentRdv } from "../store/slices/rendezVousSlice";

const useFetchRdv = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const currentRdv = useSelector(selectCurrentRdv);
  const currentRdvStatus = useSelector((state) => state.rendezvous.currentRdvStatus);
  const currentRdvError = useSelector((state) => state.rendezvous.currentRdvError);

  

  useEffect(() => {
    if (id) {
      dispatch(fetchRendezvousById(id));
    }
  }, [dispatch, id]);

  return { id, currentRdv, currentRdvStatus, currentRdvError };
};

export default useFetchRdv;
